import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../../core/layout/Card';
import Separator from '../../../../core/layout/Separator';
import PlacementTestItemHistoryBreadcrumbs from './PlacementTestItemHistoryBreadcrumbs';
import PlacementTestItemHistoryDetail from './PlacementTestItemHistoryDetail';
import ItemHistoryListContainer from '../ItemHistoryListContainer';

const PlacementTestItemHistoryScene = (props) => (
  <div>
    <PlacementTestItemHistoryBreadcrumbs placementTestItem={props.placementTestItem} fetching={props.fetching} />
    <Separator />
    <PlacementTestItemHistoryDetail placementTestItem={props.placementTestItem} fetching={props.fetching} />
    <Card title="History" loading={props.fetching}>
      <ItemHistoryListContainer itemId={props.placementTestItem.item.id} />
    </Card>
  </div>
);

PlacementTestItemHistoryScene.propTypes = {
  fetching: PropTypes.bool,
  placementTestItem: PropTypes.shape({
    grammarPlacementTestLevel: PropTypes.shape({
      id: PropTypes.string.isRequired,
      placementTestLevel: PropTypes.shape({
        level: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
    item: PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      grammar: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

PlacementTestItemHistoryScene.defaultProps = {
  fetching: false,
};

export default PlacementTestItemHistoryScene;
